import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/news/delay_icon.png'
import _imports_1 from '@/assets/news/arrow_right.png'


const _withScopeId = n => (_pushScopeId("data-v-69dede3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-warp" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "quote-row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "quote-data" }
const _hoisted_6 = { class: "quote-name" }
const _hoisted_7 = {
  class: "code",
  style: {"color":"#5a5f6e"}
}
const _hoisted_8 = {
  key: 0,
  class: "delay-icon",
  src: _imports_0,
  alt: "延时"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("-- --")
const _hoisted_10 = { class: "quote-chart" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "content-row" }
const _hoisted_13 = { class: "left-col" }
const _hoisted_14 = { class: "banner-wrap" }
const _hoisted_15 = { class: "banner-advert-slider" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "banner-advert-dots"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "col-header" }
const _hoisted_22 = { class: "col-title" }
const _hoisted_23 = { class: "more" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "16",
    height: "16",
    alt: ""
  })
], -1))
const _hoisted_25 = {
  key: 0,
  class: "col-loading"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "news-item__body" }
const _hoisted_28 = { class: "news-item__content" }
const _hoisted_29 = { class: "news-item__title" }
const _hoisted_30 = { class: "stock-content" }
const _hoisted_31 = {
  key: 0,
  class: "feed-item__top-icon"
}
const _hoisted_32 = {
  key: 1,
  class: "news-item__stock-row"
}
const _hoisted_33 = { class: "stock-market" }
const _hoisted_34 = { class: "stock-name" }
const _hoisted_35 = {
  key: 0,
  src: _imports_0,
  class: "delay-icon-sm",
  alt: "延时"
}
const _hoisted_36 = { class: "news-item__footer" }
const _hoisted_37 = { class: "news-item__source" }
const _hoisted_38 = { class: "news-item__time" }
const _hoisted_39 = {
  key: 0,
  class: "news-item__thumb"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "mid-col" }
const _hoisted_42 = { class: "hot-wrap" }
const _hoisted_43 = { class: "hot-wrap-box" }
const _hoisted_44 = { class: "hot-list" }
const _hoisted_45 = {
  key: 0,
  class: "col-loading"
}
const _hoisted_46 = { class: "section-header" }
const _hoisted_47 = { class: "section-title" }
const _hoisted_48 = { class: "update-time" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "hot-text" }
const _hoisted_51 = { class: "col-header" }
const _hoisted_52 = { class: "col-title" }
const _hoisted_53 = { class: "more" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "16",
    height: "16",
    alt: ""
  })
], -1))
const _hoisted_55 = {
  key: 0,
  class: "col-loading"
}
const _hoisted_56 = {
  key: 1,
  class: "zx-empty"
}
const _hoisted_57 = { class: "zx-empty-text" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "news-item__body" }
const _hoisted_60 = { class: "news-item__content" }
const _hoisted_61 = { class: "news-item__title" }
const _hoisted_62 = {
  key: 0,
  class: "news-item__stock-row"
}
const _hoisted_63 = { class: "stock-market" }
const _hoisted_64 = { class: "stock-name" }
const _hoisted_65 = {
  key: 0,
  src: _imports_0,
  class: "delay-icon-sm",
  alt: "延时"
}
const _hoisted_66 = { class: "news-item__footer" }
const _hoisted_67 = { class: "news-item__source" }
const _hoisted_68 = { class: "news-item__time" }
const _hoisted_69 = {
  key: 0,
  class: "news-item__thumb"
}
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "right-col" }
const _hoisted_72 = { class: "col-header" }
const _hoisted_73 = { class: "col-title" }
const _hoisted_74 = { class: "more" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "16",
    height: "16",
    alt: ""
  })
], -1))
const _hoisted_76 = {
  key: 0,
  class: "col-loading"
}
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { class: "zhiyan-content" }
const _hoisted_79 = { class: "zhiyan-info" }
const _hoisted_80 = { class: "zhiyan-title" }
const _hoisted_81 = {
  key: 0,
  class: "zhiyan-tags"
}
const _hoisted_82 = {
  key: 0,
  class: "stock-market-tag"
}
const _hoisted_83 = {
  key: 1,
  class: "stock-tag"
}
const _hoisted_84 = {
  key: 2,
  src: _imports_0,
  class: "delay-icon-sm",
  alt: "延时"
}
const _hoisted_85 = { class: "zhiyan-source" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = {
  key: 0,
  class: "zhiyan-thumb"
}
const _hoisted_88 = ["src"]
const _hoisted_89 = { class: "col-header" }
const _hoisted_90 = { class: "col-title" }
const _hoisted_91 = { class: "more" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "16",
    height: "16",
    alt: ""
  })
], -1))
const _hoisted_93 = { class: "live-date-row" }
const _hoisted_94 = { class: "live-date-text" }
const _hoisted_95 = { class: "live-refresh-area" }
const _hoisted_96 = { class: "auto-refresh-label" }
const _hoisted_97 = { class: "live-timeline" }
const _hoisted_98 = {
  key: 0,
  class: "col-loading"
}
const _hoisted_99 = ["onClick"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "live-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "live-dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "live-line" })
], -1))
const _hoisted_101 = { class: "live-right" }
const _hoisted_102 = { class: "live-time" }
const _hoisted_103 = { class: "live-text" }

import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import moment from 'moment'
import * as echarts from 'echarts'
import infoApi from '@/api/info'
import { zh_tran, objTran } from '@/utils/lang.js'
import ws from '@/websocket/index'
import { resolveMarket, getFDMarketTag, getFDMarketRegion } from '@/websocket/quotationWebsocket'
import { getStockClass, FDRouter } from '@/utils/stock'
import { openNewsWindow, reportBuriedPoint, reportAdvertClick, reportAdvertExposure, parseAdvertClickType, resolveAdvertJumpLink, getAdvertPopupFrequency } from '@/utils/news'

import FDEmptyData from '@/components/FDEmptyData.vue'
interface HotItem {
  title: string
  articleId: string
  url: string
  data?: { url?: string }
  id: number
  type: string
  updatedTime: string
}

interface LiveItem {
  id: number
  title: string
  createTime: string
  timestamp: number
  decryptId?: string
}

interface ZhiyanItem {
  id: number
  title: string
  source: string
  createTime: string
  createTimeFormat?: string
  dataType?: number
  symbol?: string
  stockName?: string
  market?: string
  changeRate?: number
  image?: string
  decryptId?: string
}

interface NewsItem {
  newsId: number
  title: string
  columnCodeName: string
  createTimeFormat: string
  publishTime?: number
  decryptId?: string
  isTop?: number
  img?: { url: string }
  stockInfo?: { symbol?: string; name?: string; exchange?: string; market?: string; fluctuation_range?: number | null }
}

interface BannerAdvertMaterialInfo {
  pcJumpLink?: string
  guideContent?: string
  simpleBlack?: string
  simpleWhite?: string
  tradBlack?: string
  tradWhite?: string
  adCode?: string
  sourceId?: string
  dailyFreguency?: string | number
  frequencyType?: string | number
  [key: string]: any
}
interface BannerAdvertItem {
  materialInfos?: BannerAdvertMaterialInfo[]
  adCode?: string
  dailyFrequency?: string | number | null
  frequencyType?: string | number | null
  [key: string]: any
}
interface BannerAdvertSlide {
  img: string
  link: string
  adCode: string
  sourceId: string
  popupFrequency: string | number
  idx: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {

const BURIED_EVENT = 'module_event'
const BURIED_PAGE = 'new_fdgl_assembly'

function track(moduleEvent: string) {
  reportBuriedPoint(BURIED_EVENT, { module_event: moduleEvent, page_title: BURIED_PAGE })
}


const route = useRoute()
const router = new FDRouter(useRouter())
const isDark = computed(() => (route.query.theme as string) === 'dark')
const prefer = route.query.preferGreenUptrendRedDowntrend as string | null

// ─── 繁体支持 ─────────────────────────────────────────────────────────────────
const lang = (route.query['Accept-Language'] as string) || 'zh-Hans'
const isTraditional = computed(() => lang === 'zh-Hant')

function tran(text: string): string {
  if (!text) return text
  if (isTraditional.value) return (text as any).tran()
  return text
}

const quoteList = ref([
  { name: '恒生指数', code: 'HSI', symbol: '.HSI', marketid: 118, price: null as number | null, change: null as number | null, changePct: null as number | null },
  { name: '国企指数', code: 'HSCEI', symbol: '.HSCE', marketid: 118, price: null as number | null, change: null as number | null, changePct: null as number | null },
  { name: '红筹指数', code: 'HSCCI', symbol: '.HSCC', marketid: 118, price: null as number | null, change: null as number | null, changePct: null as number | null },
  { name: '恒生科技指数', code: 'HSTECH', symbol: '.HSTECH', marketid: 118, price: null as number | null, change: null as number | null, changePct: null as number | null },
])

// 延时行情标识：HKDELAY=0 实时，HKDELAY=1 延时
const hkDelay = (route.query.HKDELAY as string) === '1'
const usDelay = (route.query.USDELAY as string) === '1'
console.log('route.query.HKDELAY', hkDelay, 'USDELAY', usDelay)
const HK_INDEX_MARKET = hkDelay ? 'DELAY_HKIDX' : 'HKIDX'
const HK_INDEX_LIST_KEY = 'overview_hk_index'

// 港股 market 集合
// 延时时 market 映射表
function resolveMarketLocal(market: string): string {
  return resolveMarket(market, hkDelay, usDelay)
}

function isDelayedStock(market: string | undefined): boolean {
  if (!market) return false
  const region = getFDMarketRegion(market)
  if (region === 'HK' && hkDelay) return true
  if (region === 'US' && usDelay) return true
  return false
}

// 分时图数据：key = symbol
const minDataMap = ref<Record<string, { closes: number[], times: number[], preClose: number, tradingDay: number }>>({})
const chartInstances: Record<string, any> = {}

function initMinChart(symbol: string, domId: string, preClose: number, closes: number[]) {
  const dom = document.getElementById(domId)
  if (!dom) return
  if (chartInstances[symbol]) {
    chartInstances[symbol].dispose()
  }
  const chart = echarts.init(dom)
  chartInstances[symbol] = chart
  renderMinChart(chart, preClose, closes)
}

function renderMinChart(chart: any, preClose: number, closes: number[]) {
  const HK_POINTS = 331
  const data: (number | null)[] = new Array(HK_POINTS).fill(null)
  closes.forEach((v, i) => { if (i < HK_POINTS) data[i] = v })
  const validCloses = closes.filter(v => v != null && v > 0)
  const greenUp = prefer === '1'
  const upColor = greenUp ? '#00b578' : '#fe4043'
  const downColor = greenUp ? '#fe4043' : '#00b578'
  let color = '#8a8f9e'
  if (validCloses.length && preClose) {
    const last = validCloses[validCloses.length - 1]
    color = last > preClose ? upColor : last < preClose ? downColor : '#8a8f9e'
  }
  chart.setOption({
    grid: { top: 2, right: 2, bottom: 2, left: 2 },
    xAxis: { type: 'category', show: false, data: data.map((_, i) => i) },
    yAxis: {
      type: 'value', show: false,
      min: (v: any) => v.min - Math.abs(v.max - v.min) * 0.3,
      max: (v: any) => v.max + Math.abs(v.max - v.min) * 0.3,
    },
    series: [{
      type: 'line', data, showSymbol: false, animation: false,
      lineStyle: { color, width: 1 },
      areaStyle: {
        color: {
          type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [{ offset: 0, color: color + '55' }, { offset: 1, color: color + '00' }]
        }
      },
    }],
  }, false)
}

function updateMinChart(symbol: string) {
  const inst = chartInstances[symbol]
  if (!inst) return
  const d = minDataMap.value[symbol]
  if (!d) return
  renderMinChart(inst, d.preClose, d.closes)
}

const hotList = ref<HotItem[]>([])
const updateTime = ref('')
const zhiyanList = ref<ZhiyanItem[]>([])
const ywList = ref<NewsItem[]>([])
const zxList = ref<NewsItem[]>([])

// 各区块加载状态
const loadingHot = ref(false)
const loadingLive = ref(false)
const loadingZhiyan = ref(false)
const loadingYw = ref(false)
const loadingZx = ref(false)
const zxLoaded = ref(false)

// 每列可显示条数
const COL_HEADER_H = 27
const NEWS_ITEM_MIN = 100
const LIVE_ITEM_MIN = 54
// content-row 高度 = 100vh - 194px（top-warp 160px + padding 32px + border 2px）
const CONTENT_ROW_OFFSET = 194
const NEWS_COL_RATIO = ref(0.55)
const LIVE_DATE_ROW_H = 44

// 用 ref 驱动 v-bind CSS，保证样式与计算逻辑同源
const ZHIYAN_RATIO = ref(0.53)
const LIVE_RATIO = ref(0.466)

function calcCount(containerH: number, headerH: number, itemMin: number): number {
  const available = containerH - headerH
  return Math.max(1, Math.floor(available / itemMin))
}

function openAddSelfSelect() {
  window.open('gw://funccall?funcname=OnDoCommand;param=自选.全部自选')
}

function calcCounts() {
  const contentH = window.innerHeight - CONTENT_ROW_OFFSET
  const newsColH = contentH * NEWS_COL_RATIO.value
  const zhiyanH = contentH * ZHIYAN_RATIO.value
  const liveH = contentH * LIVE_RATIO.value

  ywCount.value = calcCount(newsColH, COL_HEADER_H, NEWS_ITEM_MIN)
  zxCount.value = calcCount(newsColH, COL_HEADER_H, NEWS_ITEM_MIN)
  zhiyanCount.value = calcCount(zhiyanH, COL_HEADER_H, NEWS_ITEM_MIN)
  liveCount.value = calcCount(liveH, COL_HEADER_H + LIVE_DATE_ROW_H, LIVE_ITEM_MIN)
}

const ywCount = ref(5)
const zxCount = ref(5)
const zhiyanCount = ref(3)
const liveCount = ref(5)

const ywListSliced = computed(() => ywList.value.slice(0, ywCount.value))
const zxListSliced = computed(() => zxList.value.slice(0, zxCount.value))
const zhiyanListSliced = computed(() => zhiyanList.value.slice(0, zhiyanCount.value))
const liveListSliced = computed(() => liveList.value.slice(0, liveCount.value))

// --- 7x24 ---
const liveList = ref<LiveItem[]>([])
const selectedLiveId = ref<number | null>(null)
const autoRefresh = ref(true)
const countdown = ref(60)
let countdownTimer: ReturnType<typeof setInterval> | null = null

const WEEK_DAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
const todayLabel = computed(() => {
  const now = new Date()
  const m = now.getMonth() + 1
  const d = now.getDate()
  const w = WEEK_DAYS[now.getDay()]
  return `${m}月${d}日 ${w}`
})

const formatHHMM = (ts: number | string) => {
  if (!ts) return ''
  const ms = typeof ts === 'number' && ts < 1e12 ? ts * 1000 : Number(ts)
  const m = moment(ms)
  return m.isValid() ? m.format('HH:mm') : ''
}

const fetchLiveNews = async () => {
  const timestamp = Math.floor(Date.now() / 1000)
  try {
    const res: any = await infoApi.discoverNews({
      data: { timestamp, pageSize: 10, type: 1, specialCode: '7x24' },
      headers: {}
    })
    if (res?.data?.length) {
      liveList.value = res.data.map((item: any) => ({
        id: item.id || 0,
        title: item.title || '',
        createTime: formatTimestamp(item.publishTime) || '',
        timestamp: item.timestamp || 0,
        decryptId: item.decryptId || '',
      }))
    }
  } catch (e) {
    console.error('[discoverNews error]', e)
  }
}

const jumpToIndexChart = (item: { symbol: string; marketid: number }) => {
  const url = `gw://funccall?funcname=OnFireCommand;setcurrent=1;Command=fszs;param=<params><code>${item.symbol}</code><market>${item.marketid}</market><technique_type>0</technique_type><level2_orderchart_type>-1</level2_orderchart_type><StyleName>FSZS</StyleName><TabName>分时图</TabName><flag_container_style>R</flag_container_style></params>`
  window.open(url)
}

const onManualRefresh = async () => {
  loadingLive.value = true
  await fetchLiveNews()
  loadingLive.value = false
}

const startCountdown = () => {
  if (countdownTimer) clearInterval(countdownTimer)
  countdown.value = 60
  countdownTimer = setInterval(() => {
    if (!autoRefresh.value) return
    countdown.value--
    if (countdown.value <= 0) {
      countdown.value = 60
      fetchLiveNews()
    }
  }, 1000)
}

const onLiveItemClick = (item: LiveItem) => {
  openNewsWindow(item.id, item.title, item.decryptId)
}

const formatTime = (timeStr: string) => {
  if (!timeStr) return moment().format('HH:mm')
  return moment(timeStr).isValid() ? moment(timeStr).format('HH:mm') : moment().format('HH:mm')
}

const formatTimestamp = (ts: number | string | undefined): string => {
  if (!ts) return ''
  const m = moment(typeof ts === 'number' && ts < 1e12 ? ts * 1000 : Number(ts))
  return m.isValid() ? m.format('YYYY-MM-DD HH:mm') : String(ts)
}

const newsFormatPct = (val: number | null | undefined): string => {
  if (val == null) return ''
  const fixed = val.toFixed(2)
  const sign = val >= 0 ? '+' : ''
  return `${sign}${fixed}%`
}

const newsStockClass = (val: number | null | undefined): string => {
  return getStockClass(val, prefer)
}

const onNewsClick = (item: NewsItem) => openNewsWindow(item.newsId, item.title, item.decryptId)
const onZxClick = (item: NewsItem) => openNewsWindow(item.newsId, item.title, item.decryptId)
const onZhiyanClick = (item: ZhiyanItem) => openNewsWindow(item.id, item.title, item.decryptId)

const fetchZhiYan = async () => {
  try {
    const res: any = await infoApi.getZhiYan({ data: { specialCode: 'ZY', page: 1, pageSize: 10 }, headers: {} })
    const list: any[] = res?.data?.articles || []
    zhiyanList.value = list.map((item: any) => {
      const stockInfo = item.stockInfoList?.[0] || {}
      return {
        id: item.newsId || 0,
        title: item.title || '',
        source: item.columnCodeName || '',
        createTime: formatTimestamp(item.publishTime) || '',
        dataType: item.dataType ?? null,
        symbol: stockInfo.symbol || stockInfo.code || '',
        stockName: stockInfo.name || '',
        market: stockInfo.market || '',
        changeRate: stockInfo.fluctuation_range != null ? stockInfo.fluctuation_range : null,
        image: item.img?.url || '',
        decryptId: item.decryptId || '',
        createTimeFormat: item.createTimeFormat || '',
      }
    })
    if (isTraditional.value) zhiyanList.value = objTran('t', zhiyanList.value)
  } catch (e) {
    console.error('[getZhiYan error]', e)
  }
}

const mapNewsItem = (item: any): NewsItem => ({
  newsId: item.id || 0,
  title: item.title || '',
  columnCodeName: item.columnName || '',
  createTimeFormat: item.createTimeFormat || '',
  publishTime: item.publishTime || 0,
  decryptId: item.decryptId || '',
  isTop: item.isTop ?? 0,
  img: item.imgs?.[0] || item.img || null,
  stockInfo: item.stockInfo?.[0] ? {
    symbol: item.stockInfo[0].symbol || item.stockInfo[0].code || '',
    name: item.stockInfo[0].name || '',
    exchange: item.stockInfo[0].exchange || '',
    market: item.stockInfo[0].market || '',
    fluctuation_range: item.stockInfo[0].fluctuation_range ?? null,
  } : undefined,
})

const formatZhiyanTime = (timeStr: string) => {
  if (!timeStr) return ''
  const m = moment(timeStr)
  return m.isValid() ? m.format('YYYY-MM-DD HH:mm') : timeStr
}

const NEWS_STOCK_LIST_KEY = 'overview_news_stocks'

// 订阅新闻列表中的股票行情
function subscribeNewsStocks() {
  const seen = new Set<string>()
  const stockList: Array<{ symbol: string; market: string }> = []

    ; (ywList.value as NewsItem[]).concat(zxList.value).forEach((item: NewsItem) => {
      if (item.stockInfo?.symbol && item.stockInfo?.market) {
        const key = item.stockInfo.symbol + item.stockInfo.market
        if (!seen.has(key)) {
          seen.add(key)
          stockList.push({ symbol: item.stockInfo.symbol, market: resolveMarketLocal(item.stockInfo.market) })
        }
      }
    })

  zhiyanList.value.forEach((item: ZhiyanItem) => {
    if (item.symbol && item.market) {
      const key = item.symbol + item.market
      if (!seen.has(key)) {
        seen.add(key)
        stockList.push({ symbol: item.symbol, market: resolveMarketLocal(item.market) })
      }
    }
  })

  if (stockList.length) {
    ws.websocket.safeSubscribeList(NEWS_STOCK_LIST_KEY, stockList)
  }
}

const goDetail = (item: HotItem) => {
  if (item.articleId) {
    openNewsWindow(null, item.title, item.articleId)
  } else if (item.data?.url) {
    const title = item.title || ''
    const url = `gw://webkitdlg?width=390;height=844;mode=0;title=${title};allowdestroy=1;url=${item.data.url}`
    window.open(url)
  }
}

// ─── 首页 banner 广告轮播 ──────────────────────────────────────────────────────
const bannerAdvertList = ref<BannerAdvertItem[]>([])
const bannerSlideList = ref<BannerAdvertSlide[]>([])
const bannerAdvertIndex = ref(0)
let bannerAdvertTimer: ReturnType<typeof setInterval> | null = null
const bannerExposedSet = new Set<string>()

function resolveBannerAdvertImg(info: BannerAdvertMaterialInfo): string {
  if (isTraditional.value) {
    return (isDark.value ? info.tradBlack : info.tradWhite) || ''
  }
  return (isDark.value ? info.simpleBlack : info.simpleWhite) || ''
}

function buildBannerSlideList(list: BannerAdvertItem[]): BannerAdvertSlide[] {
  const slides: BannerAdvertSlide[] = []
  let idx = 0
  for (const ad of list) {
    for (const info of ad.materialInfos || []) {
      const img = resolveBannerAdvertImg(info)
      const link = resolveAdvertJumpLink(info)
      if (img) slides.push({
        img,
        link,
        adCode: ad.adCode || '',
        sourceId: info.sourceId || '',
        popupFrequency: ad.dailyFrequency ?? ad.frequencyType ?? '',
        idx: idx++,
      })
    }
  }
  return slides
}

function reportBannerExposureOnce(slide: BannerAdvertSlide) {
  const key = String(slide.idx)
  if (bannerExposedSet.has(key)) return
  bannerExposedSet.add(key)
  reportAdvertExposure(BURIED_PAGE, {
    adCode: slide.adCode,
    sourceId: slide.sourceId,
    popupFrequency: slide.popupFrequency,
  })
}
function stopBannerAdvertTimer() {
  if (bannerAdvertTimer) {
    clearInterval(bannerAdvertTimer)
    bannerAdvertTimer = null
  }
}

function startBannerAdvertTimer() {
  stopBannerAdvertTimer()
  if (bannerSlideList.value.length <= 1) return
  bannerAdvertTimer = setInterval(() => {
    bannerAdvertIndex.value = (bannerAdvertIndex.value + 1) % bannerSlideList.value.length
    reportBannerExposureOnce(bannerSlideList.value[bannerAdvertIndex.value])
  }, 4000)
}

function onBannerAdvertClick(slide: BannerAdvertSlide) {
  // click_event 埋点
  reportAdvertClick(BURIED_PAGE, {
    adCode: slide.adCode,
    sourceId: slide.sourceId,
    link: slide.link,
  })
  if (!slide.link) return
  window.open(slide.link)
}

async function fetchBannerAdvert() {
  try {
    const commonHeaders = {
      'Content-Type': 'application/json',
      clientType: 'h5',
      'Accept-Language': (route.query['Accept-Language'] as string) || 'zh-Hans',
    }
    const res: any = await infoApi.getAdvertPage({
      data: { pageNum: 1, pageSize: 10 },
      params: { adType: 4, positionType: 90 },
      headers: commonHeaders,
    })
    console.log('fetchBannerAdvert',res)
    const list: BannerAdvertItem[] = res?.data?.data || []
    bannerAdvertList.value = list
    bannerSlideList.value = buildBannerSlideList(list)
    bannerAdvertIndex.value = 0
    startBannerAdvertTimer()
    // show_login_ad 曝光埋点：首次展示第一个 slide
    if (bannerSlideList.value.length) {
      reportBannerExposureOnce(bannerSlideList.value[0])
    }
  } catch (e) {
    console.error('[Overview] fetchBannerAdvert error', e)
  }
}

onUnmounted(() => {
  stopBannerAdvertTimer()
})

onMounted(async () => {
  if (isTraditional.value) zh_tran('t')

  // 调试：广告列表接口
  // try {
  //   const advertRes: any = await infoApi.getAdvertPage({
  //     data: { },
  //     params: { pageNum: 1, pageSize: 10 ,adType: 4, positionType: 90 },
  //     headers: { 'Content-Type': 'application/json' },
  //   })
  //   console.log('[getAdvertPage result]', advertRes)
  // } catch (e) {
  //   console.error('[getAdvertPage error]', e)
  // }

  calcCounts()
  window.addEventListener('resize', calcCounts)
  ;(window as any).on_tradingday_changed = on_tradingday_changed
  fetchBannerAdvert()

  // 订阅港股四大指数行情
  const stockList = quoteList.value.map(item => ({ symbol: item.symbol, market: HK_INDEX_MARKET }))
  ws.websocket.safeSubscribeList(HK_INDEX_LIST_KEY, stockList)

  ws.websocket.on('onHQLIST', (msg: any) => {
    const dynaData: any[] = msg?.QuoteData?.DynaData || []
    dynaData.forEach((d: any) => {
      // 更新港股指数行情
      const qItem = quoteList.value.find(q => q.symbol === d.InstrumentID)
      if (qItem) {
        qItem.price = d.LastPrice != null ? Number(d.LastPrice) : Number(qItem.price)
        qItem.change = d.Updown != null ? d.Updown : qItem.change
        qItem.changePct = d.UpdownRate != null ? d.UpdownRate : qItem.changePct
      }
      // 更新要闻/自选 stockInfo.fluctuation_range
      if (d.UpdownRate !== undefined) {
        ;[ywList.value, zxList.value].forEach(list => {
          list.forEach((item: NewsItem) => {
            if (item.stockInfo?.symbol && item.stockInfo.symbol === d.InstrumentID) {
              item.stockInfo.fluctuation_range = parseFloat((d.UpdownRate * 100).toFixed(2))
            }
          })
        })
        // 更新智研 changeRate
        zhiyanList.value.forEach((item: ZhiyanItem) => {
          if (item.symbol && item.symbol === d.InstrumentID) {
            item.changeRate = parseFloat((d.UpdownRate * 100).toFixed(2))
          }
        })
      }
    })
  })

  // 订阅分时走势（缩略图）
  quoteList.value.forEach(item => {
    ws.websocket.safeSubscribeMIN(item.symbol, HK_INDEX_MARKET)
  })

  ws.websocket.on('onMIN', (msg: any) => {
    const symbol = msg?.Inst
    if (!symbol) return
    const minList: any[] = msg?.QuoteData?.MinData || []
    if (!minList.length) return

    const preClose = minList[0]?.PreClose ?? minDataMap.value[symbol]?.preClose ?? 0
    const tradingDay: number = minList[0]?.TradingDay ?? 0
    const existing = minDataMap.value[symbol]
    console.log('onMIN',minList,minDataMap.value,)
    // 交易日变更时清空旧数据，避免跨日数据混入
    console.log('[debug] existing.tradingDay:', existing?.tradingDay, 'tradingDay:', tradingDay)
    const isSameDay = existing && tradingDay && existing.tradingDay === tradingDay
    // 用 Time 时间戳去重合并，防止重连后全量推送导致数据重复叠加
    const existingMap = new Map<number, number>()
    if (isSameDay) {
      existing.times.forEach((t: number, i: number) => existingMap.set(t, existing.closes[i]))
    } else if (existing) {
      // 跨天时销毁旧图表实例，强制下次重新初始化，避免旧数据残留在 echarts 内部
      if (chartInstances[symbol]) {
        chartInstances[symbol].dispose()
        delete chartInstances[symbol]
      }
    }
    minList.forEach((m: any) => existingMap.set(m.Time, m.Price ?? 0))
    const sortedEntries = Array.from(existingMap.entries()).sort((a, b) => a[0] - b[0])
    const allCloses = sortedEntries.map(e => e[1])
    const allTimes = sortedEntries.map(e => e[0])

    minDataMap.value[symbol] = {
      closes: allCloses,
      times: allTimes,
      preClose: preClose || existing?.preClose || 0,
      tradingDay,
    }

    const domId = `min-chart-${symbol.replace(/\./g, '')}`
    nextTick(() => {
      if (chartInstances[symbol]) {
        updateMinChart(symbol)
      } else {
        initMinChart(symbol, domId, minDataMap.value[symbol].preClose, allCloses)
      }
    })
  })

  loadingHot.value = true
  try {
    const res: any = await infoApi.getHotHeadlines({ data: {}, headers: {} })
    if (res?.data?.leadNewsList?.length) {
      hotList.value = res.data.leadNewsList.slice(0, 4).map((item: any) => ({
        title: item.title || '',
        articleId: item.articleId || '',
        url: item.data?.url || item.url || '',
        data: item.data || null,
        id: item.id || 0,
        type: item.type || '',
        updatedTime: item.updatedTime || '',
      }))
      if (isTraditional.value) hotList.value = objTran('t', hotList.value)
      updateTime.value = formatTime(res.data.updatedTime || '')
    } else {
      updateTime.value = formatTime('')
    }
  } catch (e) {
    console.error('[getHotHeadlines error]', e)
    updateTime.value = formatTime('')
  } finally {
    loadingHot.value = false
  }

  loadingLive.value = true
  await fetchLiveNews()
  loadingLive.value = false
  startCountdown()

  loadingZhiyan.value = true
  await fetchZhiYan()
  loadingZhiyan.value = false

  // 并行拉取要闻和自选
  const commonHeaders = {
    'Content-Type': 'application/json',
    clientType: 'h5',
    'Accept-Language': (route.query['Accept-Language'] as string) || 'zh-Hans',
  }
  loadingYw.value = true
  loadingZx.value = true
  const [ywRes, zxRes] = await Promise.allSettled([
    infoApi.getCatNews({ data: { page: 1, pageSize: 10, specialType: 2, specialCode: 'YW' }, headers: commonHeaders }),
    infoApi.getCatNews({ data: { page: 1, pageSize: 10, specialType: 3, specialCode: 'ZX' }, headers: commonHeaders }),
  ])

  if (ywRes.status === 'fulfilled') {
    ywList.value = ((ywRes.value as any)?.data || []).map(mapNewsItem)
    if (isTraditional.value) ywList.value = objTran('t', ywList.value)
  } else {
    console.error('[getCatNews YW error]', ywRes.reason)
  }
  loadingYw.value = false

  if (zxRes.status === 'fulfilled') {
    zxList.value = ((zxRes.value as any)?.data || []).map(mapNewsItem)
    if (isTraditional.value) zxList.value = objTran('t', zxList.value)
  } else {
    console.error('[getCatNews ZX error]', zxRes.reason)
  }
  loadingZx.value = false
  zxLoaded.value = true

  subscribeNewsStocks()
})

// C++ 调用：交易日切换时刷新页面
function on_tradingday_changed() {
  console.log('C++ 调用：交易日切换时刷新页面')
  window.location.reload()
}

onUnmounted(() => {
  delete (window as any).on_tradingday_changed
  if (countdownTimer) clearInterval(countdownTimer)
  window.removeEventListener('resize', calcCounts)
  ws.websocket.safeUnsubscribeList(HK_INDEX_LIST_KEY)
  ws.websocket.safeUnsubscribeList(NEWS_STOCK_LIST_KEY)
  quoteList.value.forEach(item => {
    ws.websocket.safeUnsubscribeMIN(item.symbol, HK_INDEX_MARKET)
    if (chartInstances[item.symbol]) {
      chartInstances[item.symbol].dispose()
      delete chartInstances[item.symbol]
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _directive_heightoverflowtitle = _resolveDirective("heightoverflowtitle")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overview", _unref(isDark) ? 'dark' : 'light'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(tran('新闻概览')), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quoteList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "quote-card",
            key: item.code,
            onClick: ($event: any) => (jumpToIndexChart(item)),
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(item.symbol), 1),
                hkDelay
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["quote-price", _unref(getStockClass)(item.change, _unref(prefer))])
              }, _toDisplayString(item.price || '--'), 3),
              _createElementVNode("div", {
                class: _normalizeClass(["quote-change", _unref(getStockClass)(item.change, _unref(prefer))])
              }, [
                (item.change == null || item.changePct == null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_9
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(item.change >= 0 ? '+' : '') + _toDisplayString(item.change) + " " + _toDisplayString(item.changePct >= 0 ? '+' : '') + _toDisplayString((item.changePct * 100).toFixed(2)) + "%", 1)
                    ], 64))
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                id: `min-chart-${item.symbol.replace(/\./g, '')}`,
                style: {"width":"100%","height":"100%"}
              }, null, 8, _hoisted_11)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (bannerSlideList.value.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: "banner-advert-track",
                    style: _normalizeStyle({ transform: `translateX(calc(-${bannerAdvertIndex.value * 100}% - ${bannerAdvertIndex.value * 16}px))` })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerSlideList.value, (slide, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: "banner-advert-item",
                        onClick: ($event: any) => (onBannerAdvertClick(slide))
                      }, [
                        _createElementVNode("img", {
                          src: slide.img,
                          class: "banner-advert-img",
                          alt: "",
                          referrerpolicy: "no-referrer"
                        }, null, 8, _hoisted_17)
                      ], 8, _hoisted_16))
                    }), 128))
                  ], 4)
                ]),
                (bannerSlideList.value.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerSlideList.value, (_, idx) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: idx,
                          class: _normalizeClass(["banner-advert-dot", { active: idx === bannerAdvertIndex.value }]),
                          onClick: _withModifiers(($event: any) => (bannerAdvertIndex.value = idx), ["stop"])
                        }, null, 10, _hoisted_19))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _unref(isDark) ? require('@/assets/news/newsHomeAdBlack.png') : require('@/assets/news/newsHomeAdWhite.png'),
                alt: "",
                class: "banner-ad-img"
              }, null, 8, _hoisted_20))
        ]),
        _createElementVNode("div", {
          class: "news-col",
          style: _normalizeStyle({ height: NEWS_COL_RATIO.value * 100 + '%' })
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(tran('要闻')), 1),
            _createElementVNode("div", {
              class: "more-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {track('assembly_Headlines'); _unref(router).push({ path: '/news/important', query: { ..._unref(route).query, selectedId: undefined } })})
            }, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(tran('更多')), 1),
              _hoisted_24
            ])
          ]),
          (loadingYw.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(tran('加载中')) + "…", 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(ywListSliced), (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "news-item",
                  key: item.newsId || idx,
                  onClick: ($event: any) => (onNewsClick(item))
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ])), [
                        [_directive_heightoverflowtitle, item.title]
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        (item.isTop === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(tran('置顶')), 1))
                          : _createCommentVNode("", true),
                        (item.stockInfo && item.stockInfo.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(getFDMarketTag)(item.stockInfo.market)), 1),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(item.stockInfo.name) + "(" + _toDisplayString(item.stockInfo.symbol) + ")", 1),
                              (isDelayedStock(item.stockInfo.market))
                                ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                : _createCommentVNode("", true),
                              (item.stockInfo.fluctuation_range != null)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(["stock-pct", newsStockClass(item.stockInfo.fluctuation_range)])
                                  }, _toDisplayString(newsFormatPct(item.stockInfo.fluctuation_range)), 3))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("span", _hoisted_37, _toDisplayString(item.columnCodeName), 1),
                        _createElementVNode("span", _hoisted_38, _toDisplayString(item.createTimeFormat), 1)
                      ])
                    ]),
                    (item.img?.url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("img", {
                            src: item.img.url,
                            alt: ""
                          }, null, 8, _hoisted_40)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_26))
              }), 128))
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              (loadingHot.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(tran('加载中')) + "…", 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("span", _hoisted_47, _toDisplayString(tran('热门头条')), 1),
                      _createElementVNode("span", _hoisted_48, _toDisplayString(tran('更新于')) + " " + _toDisplayString(updateTime.value), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotList.value, (item, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "hot-item",
                        key: idx,
                        onClick: ($event: any) => (goDetail(item))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["hot-num", idx < 3 ? 'top' : ''])
                        }, _toDisplayString(idx + 1), 3),
                        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_50, [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ])), [
                          [_directive_widthoverflowtitle, item.title]
                        ])
                      ], 8, _hoisted_49))
                    }), 128))
                  ], 64))
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "news-col",
          style: _normalizeStyle({ height: NEWS_COL_RATIO.value * 100 + '%' })
        }, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("span", _hoisted_52, _toDisplayString(tran('自选')), 1),
            _createElementVNode("div", {
              class: "more-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {track('assembly_Collect'); _unref(router).push({ path: '/news/optional', query: { ..._unref(route).query, selectedId: undefined } })})
            }, [
              _createElementVNode("div", _hoisted_53, _toDisplayString(tran('更多')), 1),
              _hoisted_54
            ])
          ]),
          (loadingZx.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(tran('加载中')) + "…", 1))
            : (zxLoaded.value && !_unref(zxListSliced).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createVNode(FDEmptyData, { text: "" }),
                  _createElementVNode("div", _hoisted_57, [
                    _createTextVNode(_toDisplayString(tran('当前您还没有添加自选，快去')), 1),
                    _createElementVNode("span", {
                      class: "zx-empty-link",
                      onClick: openAddSelfSelect
                    }, _toDisplayString(tran('添加自选')), 1),
                    _createTextVNode(_toDisplayString(tran('吧~')), 1)
                  ])
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(zxListSliced), (item, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "news-item",
                    key: item.newsId || idx,
                    onClick: ($event: any) => (onZxClick(item))
                  }, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ])), [
                          [_directive_heightoverflowtitle, item.title]
                        ]),
                        (item.stockInfo && item.stockInfo.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(getFDMarketTag)(item.stockInfo.market)), 1),
                              _createElementVNode("span", _hoisted_64, _toDisplayString(item.stockInfo.name) + "(" + _toDisplayString(item.stockInfo.symbol) + ")", 1),
                              (isDelayedStock(item.stockInfo.market))
                                ? (_openBlock(), _createElementBlock("img", _hoisted_65))
                                : _createCommentVNode("", true),
                              (item.stockInfo.fluctuation_range != null)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(["stock-pct", newsStockClass(item.stockInfo.fluctuation_range)])
                                  }, _toDisplayString(newsFormatPct(item.stockInfo.fluctuation_range)), 3))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("span", _hoisted_67, _toDisplayString(item.columnCodeName), 1),
                          _createElementVNode("span", _hoisted_68, _toDisplayString(item.createTimeFormat), 1)
                        ])
                      ]),
                      (item.img?.url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _createElementVNode("img", {
                              src: item.img.url,
                              alt: ""
                            }, null, 8, _hoisted_70)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_58))
                }), 128))
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", {
          class: "zhiyan-wrap",
          style: _normalizeStyle({ height: ZHIYAN_RATIO.value * 100 + '%' })
        }, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("span", _hoisted_73, _toDisplayString(tran('智研')), 1),
            _createElementVNode("div", {
              class: "more-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {track('assembly_Study'); _unref(router).push({ path: '/news/zhiyan', query: { ..._unref(route).query, selectedId: undefined } })})
            }, [
              _createElementVNode("div", _hoisted_74, _toDisplayString(tran('更多')), 1),
              _hoisted_75
            ])
          ]),
          (loadingZhiyan.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(tran('加载中')) + "…", 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(zhiyanListSliced), (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "zhiyan-item",
                  key: item.id || idx,
                  onClick: ($event: any) => (onZhiyanClick(item))
                }, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_80, [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ])), [
                        [_directive_heightoverflowtitle, item.title]
                      ]),
                      (item.market || item.stockName || item.changeRate != null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                            (item.market)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_unref(getFDMarketTag)(item.market)), 1))
                              : _createCommentVNode("", true),
                            (item.stockName)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(item.stockName) + "(" + _toDisplayString(item.symbol) + ")", 1))
                              : _createCommentVNode("", true),
                            (isDelayedStock(item.market))
                              ? (_openBlock(), _createElementBlock("img", _hoisted_84))
                              : _createCommentVNode("", true),
                            (item.changeRate != null)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 3,
                                  class: _normalizeClass(["stock-change", _unref(getStockClass)(item.changeRate ?? 0, _unref(prefer))])
                                }, _toDisplayString((item.changeRate ?? 0) >= 0 ? '+' : '') + _toDisplayString((item.changeRate ?? 0).toFixed(2)) + "% ", 3))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_85, [
                        _createTextVNode(_toDisplayString(item.source) + " ", 1),
                        (item.dataType)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(item.dataType === 4 ? '视频' :
                  '文章'), 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.createTimeFormat || item.createTime), 1)
                      ])
                    ]),
                    (item.image)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                          _createElementVNode("img", {
                            src: item.image,
                            alt: ""
                          }, null, 8, _hoisted_88)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_77))
              }), 128))
        ], 4),
        _createElementVNode("div", {
          class: "live-wrap",
          style: _normalizeStyle({ height: LIVE_RATIO.value * 100 + '%' })
        }, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("span", _hoisted_90, _toDisplayString(tran('7X24快讯')), 1),
            _createElementVNode("div", {
              class: "more-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => {track('assembly_Flashnews'); _unref(router).push({ path: '/news/live', query: { ..._unref(route).query, selectedId: undefined } })})
            }, [
              _createElementVNode("div", _hoisted_91, _toDisplayString(tran('更多')), 1),
              _hoisted_92
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("span", _hoisted_94, _toDisplayString(tran('今日')) + "(" + _toDisplayString(_unref(todayLabel)) + ")", 1),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("label", _hoisted_96, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((autoRefresh).value = $event))
                }, null, 512), [
                  [_vModelCheckbox, autoRefresh.value]
                ]),
                _createElementVNode("span", null, _toDisplayString(countdown.value) + "s" + _toDisplayString(autoRefresh.value ? tran('后自动刷新') : tran('已暂停')), 1)
              ]),
              _createElementVNode("span", {
                class: "manual-refresh-btn",
                onClick: onManualRefresh
              }, "↻")
            ])
          ]),
          _createElementVNode("div", _hoisted_97, [
            (loadingLive.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(tran('加载中')) + "…", 1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(liveListSliced), (item, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "live-item",
                    key: item.id || idx,
                    onClick: ($event: any) => (onLiveItemClick(item))
                  }, [
                    _hoisted_100,
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("span", _hoisted_102, _toDisplayString(formatHHMM(item.timestamp)), 1),
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_103, [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ])), [
                        [_directive_heightoverflowtitle, item.title]
                      ])
                    ])
                  ], 8, _hoisted_99))
                }), 128))
          ])
        ], 4)
      ])
    ])
  ], 2))
}
}

})